<template>
    <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" v-if="['escalated', 'escalated_send', 'escalated_done'].indexOf(status) !== -1">
        <template #trigger>
            <b-button
                type="is-black"
                size="is-small"
                icon-right="chevron-down" />
        </template>

        <b-dropdown-item aria-role="listitem" @click="toggleEscalationStatus">{{ status == 'escalated_done' ? 'Markeren als niet afgerond' : 'Markeren als afgerond' }}</b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: 'EscalationOptionsDropdown',

    props: {
        id: {
            type: Number,
            required: true
        },

        status: {
            type: String,
            required: false,
            default: null
        }
    },

    methods: {
        toggleEscalationStatus() {
            axios.post(`/api/invoices/${this.id}/escalation-status`, {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.$emit('reload')
            }).catch((error) => {
                console.error('[❌] Error while changing status:', error)
            })
        }
    }
}
</script>